import type { ResourceName } from '@root/@types/types';

export const isTemplateResource = (resourceName?: ResourceName) => resourceName === 'templates';
